/**
 * Route patterns that more than one module has to agree on, kept import-free
 * on purpose: `routes.ts` pulls in every page element, so anything a page (or
 * a page's tour registry) imports from it would close an import cycle.
 */

/** The Logistics page — the route the page tour registry keys its tour to. */
export const LOGISTICS_SITE_ROUTE = '/logistics/:siteId';

/** The Documents page — same reason. */
export const DOCUMENTS_SITE_ROUTE = '/documents/:siteId';

/** The annotations viewer, a document opened from the Documents page. */
export const ANNOTATIONS_SITE_ROUTE = `${DOCUMENTS_SITE_ROUTE}/annotate`;
